import { render } from "./notice-news-skeleton.vue?vue&type=template&id=4e92da04&scoped=true"
import script from "./notice-news-skeleton.vue?vue&type=script&lang=js"
export * from "./notice-news-skeleton.vue?vue&type=script&lang=js"

import "./notice-news-skeleton.vue?vue&type=style&index=0&id=4e92da04&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e92da04"]])

export default __exports__